import * as React from "react";
import Grid from "@mui/material/Grid";
import TopBar from "../../components/TopBar/TopBar";
import { LayoutPage } from "../../components/Layout/layoutPage";
import {
  Alert,
  AlertTitle,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  MenuItem,
  Radio,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import TabsCustom from "../../components/Tabs/Tabs";
import { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import "redux";
import { makeStyles } from "@mui/styles";
import { useFormik } from "formik";
import * as yup from "yup";
import { InputCustom } from "../../components/Input/InputCustom";
import axios from "axios";
import Loading from "../../components/Loading/loading";
import GridPreventivi from "../../components/GrdiPreventivi/gridPreventivi";
import FormControlLabel from "@mui/material/FormControlLabel";
import { importBaseActions } from "../../store/reducers/base";
import { getProductName } from "../../Utility";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {useNavigationStack} from "../../v2/providers/NavigationContext";
import { InstallationType } from "../../v2/core/common_types";
import RadioItemDimensioni from "../../components/Dialog/radioItemDimensioni";
import { DialogCustom } from "../../components/Dialog/dialog";
import { AspettoApi } from "../../api/AspettoApi";
import DeleteConfigurationButton from "../../components/Layout/DeleteButton";

const validationSchema = yup.object({
  qty: yup
    .number()
    .typeError("Inserire un numero intero")
    .required("Quantità richiesta obbligatoria"),
  altezza: yup
    .number()
    .typeError("Inserire un numero valido")
    .required("Altezza obbligatoria"),
  larghezza: yup
    .number()
    .typeError("Inserire un numero valido")
    .required("Larghezza obbligatoria"),
  architrave: yup
    .number()
    .typeError("Inserire un numero valido")
    .required("Architrave obbligatoria"),
  spallettaSX: yup
    .number()
    .typeError("Inserire un numero valido")
    .required("Spalletta Sinistra obbligatoria"),
  spallettaDX: yup
    .number()
    .typeError("Inserire un numero valido")
    .required("Spalletta Destra obbligatoria"),
  // SMuroSuperiore: yup
  //   .number()
  //   .typeError("Inserire un numero valido"),
  // SMuroSinistro: yup
  //   .number()
  //   .typeError("Inserire un numero valido"),
  // SMuroDestro: yup
  //   .number()
  //   .typeError("Inserire un numero valido"),
  PGarage: yup
    .number()
    .typeError("Inserire un numero valido")
    .required("Profondità Garage obbligatoria"),
});

const Dimensioni = () => {
  const { stack, goToStack, getLastIndex } = useNavigationStack();
  const state = useSelector(state => state.base);
  const dispatch = useDispatch();
  const baseActions = importBaseActions();
  const [data, setData] = useState({
    state: "loading",
    steps: [],
    currentStep: null,
    dimensioni: null
  });

  //const history = useHistory();
  const navigate = useNavigate();
  const classes = useStyles();
  const [errorVincolo, setErrorVincolo] = useState(null);

  const location = useLocation();
  const [value, setValue] = useState(0);
  let axiosConfig = {
    headers: {
      Authorization: "Bearer " + state.user.token,
    },
  };

  const [checked, setChecked] = useState(state.selectedD);
  const [submit, setSubmit] = useState(false);
  const [switchPorticinaAffiancata, setSwitchPorticinaAffiancata] = useState(state.isPorticinaAffiancata);
  const [errorModal, setErrorModal] = useState("");
  const [loadingModal, setLoadingModal] = useState(false);
  const [warning, setWarning] = useState("");
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalOptions, setModalOptions] = useState({
    show: false,
    options: null,
    selectedCrossbeam: null,
    selectedPillars: null,
    state: "idle",
    error: null
  });

  const [dataModal, setDataModal] = useState();
  const [modalValueLarghezza, setModalValueLarghezza] = useState();
  const [modalValueAltezza, setModalValueAltezza] = useState();

  const handleChange = () => {
    // data &&
    //   data.map((el) =>
    //     `/${el.slug}` === location.pathname ? setValue(el.id) : null
    //   );
  };

  const getData = () => {
    formik.setFieldValue("altezza", state.altezza);
    formik.setFieldValue("larghezza", state.larghezza);
    formik.setFieldValue("architrave", state.architrave);
    formik.setFieldValue("spallettaSX", state.spallettaSinistra);
    formik.setFieldValue("spallettaDX", state.spallettaDestra);
    formik.setFieldValue("SMuroSuperiore", state.SMuroSuperiore);
    formik.setFieldValue("SMuroSinistro", state.SMuroSinistro);
    formik.setFieldValue("SMuroDestro", state.SMuroDestro);
    formik.setFieldValue("PGarage", state.PGarage);
  };

  useEffect(() => {
    //return getData();
    console.log(location.state)
    load();
  }, []);

  const load = async () => {
    let steps = [];
    let currentStep = null;
    try {
      let res = await axios.post(`${process.env.REACT_APP_API_URL}/categories-steps`, { id: state.idPorta, quote_id: state.quoteId }, axiosConfig);
      console.log(res);
      if (res.data && res.data.data) {
        steps = res.data.data;
        currentStep = findCategoryStep(steps);
        console.log(currentStep);
      }
    } catch (e) {

    }

    try {
      let res = await axios.post(`${process.env.REACT_APP_API_URL}/get-dimensioni`, { id: state.customer ? state.customer.id : state.user.id, quote: state.quoteId }, axiosConfig);

      let dimensioni = res.data.data;
      if (dimensioni) {
        formik.setFieldValue("qty", dimensioni.qty);
        formik.setFieldValue("altezza", dimensioni.height);
        formik.setFieldValue("larghezza", dimensioni.width);
        formik.setFieldValue("architrave", dimensioni.architrave);
        formik.setFieldValue("spallettaSX", dimensioni.distance_ss);
        formik.setFieldValue("spallettaDX", dimensioni.distance_ds);
        formik.setFieldValue("SMuroSuperiore", dimensioni.upper_wall_thickness);
        formik.setFieldValue("SMuroSinistro", dimensioni.left_wall_thickness);
        formik.setFieldValue("SMuroDestro", dimensioni.right_wall_thickness);
        formik.setFieldValue("PGarage", dimensioni.garage_depth);
        formik.setFieldValue("locale_con_accesso", dimensioni.locale_con_accesso == 1);
        formik.setFieldValue("withDoor", dimensioni.with_door == 1);
        formik.setFieldValue("with_side_door", dimensioni.with_side_door == 1);
        formik.setFieldValue("isDebordante", dimensioni.is_debordante == 1);
        formik.setFieldValue("installazioneTraversa", dimensioni.crossbeam_installation_id ?? "");
        formik.setFieldValue("installazioneMontanteSx", dimensioni.sx_pillar_installation_id ?? "");
        formik.setFieldValue("installazioneMontanteDx", dimensioni.dx_pillar_installation_id ?? "");

        dispatch(baseActions.setSelectedD(dimensioni.locale_con_accesso == 1));
        dispatch(baseActions.setIsPorticina(dimensioni.with_door == 1));
        dispatch(baseActions.setIsDebordante(dimensioni.is_debordante == 1));
        dispatch(baseActions.setIsPorticinaAffiancata(dimensioni.with_side_door == 1));
      }

      setData({
        state: "idle",
        steps: steps,
        currentStep: currentStep,
        dimensioni
      });
    } catch (e) {
      console.error(e);
      setData({ state: "error", error: e });
    }
  }

  const findCategoryStep = (categoriesSteps) => {
    return categoriesSteps.find(cs => `/${cs.slug}` === location.pathname);
  };

  const navigateToNextStep = () => {
    let nextStep = null;
    let stepsIds = data.steps.map(s => s.position);
    let maxStepId = Math.max(...stepsIds);

    for (let stepId = data.currentStep.position + 1; stepId <= maxStepId; stepId++) {
      let step = data.steps.find(s => s.position == stepId);
      if (!step) continue;
      if (state.fullglass && (step.position == 6 || step.position == 7 || step.position == 8)) {
        continue;
      }
      nextStep = step;
      if (nextStep) break;
    }
    if (!nextStep) return;

    navigate(`/${nextStep.slug}`, {
      id: state.idPorta,
    });
  }

  const setQty = (value) => {
    formik.setFieldValue("qty", value);
  }

  const isValidQta = (value) => !isNaN(value) && value > 0;
  const [erroreQta, setErroreQta] = useState(null);

  const saveSector = async () => {
    if (dataModal.altezza.length > 1 && !modalValueAltezza) {
      setErrorModal("Per continuare è necessario selezionare un'altezza tra quelle proposte");
      return;
    }

    if (dataModal.lunghezza.length > 1 && !modalValueLarghezza) {
      setErrorModal("Per continuare è necessario selezionare una larghezza tra quelle proposte");
      return;
    }

    setLoadingModal(true);
    try {
      let res = await axios.post(`${process.env.REACT_APP_API_URL}/save-sector`, {
        nameAltezza: dataModal.altezza.length === 1 ? dataModal.altezza[0].name : modalValueAltezza,
        nameLarghezza: dataModal.lunghezza.length === 1 ? dataModal.lunghezza[0].name : modalValueLarghezza,
        category_id: state.idPorta,
        id: state.quoteId,
      }, axiosConfig);

      debugger

      if (res.data.data === "Warning") {
        setErrorVincolo(res.data.message);
        setModal(false);
        setDataModal(null);
        setLoadingModal(false);
        //formik.setFieldValue("installazione", 7);
        setLoading(false);
        return;
      }
      if (res.data.success === 1) {
        setModal(false);
        setLoadingModal(false);
        if (res.data.message != "modal") {
          navigateToNextStep();
        } else {
          let crossbeam = res.data.data.crossbeam ? res.data.data.crossbeam.find(i => i.selected).item.id : null;
          let pillars = res.data.data.pillars ? res.data.data.pillars.find(i => i.selected).item.id : null;
          setModalOptions({
            show: true,
            options: res.data.data,
            selectedCrossbeam: crossbeam,
            selectedPillars: pillars
          });
        }
      } else {
        //setModal(false);
        setLoadingModal(false);
        setErrorModal(res.data.message);
      }
    } catch (error) {
      setLoadingModal(false);
      console.log(error);
    }
  }

  const setInstallationAccessories = async () => {
    if (!modalOptions.selectedCrossbeam && !modalOptions.selectedPillars) {
      setModalOptions({ ...modalOptions, state: "error", error: "Nessuna opzione selezionata" });
      return;
    }

    setModalOptions({ ...modalOptions, state: "save", error: null });
    let res = await AspettoApi.saveInstallationAccessories(state.user.token, {
      quoteId: state.quoteId,
      accessorioTraversa: modalOptions.selectedCrossbeam,
      accessorioMontanti: modalOptions.selectedPillars,
    });

    navigateToNextStep();
  }

  // useEffect(() => {
  //   cache.clear();
  //   return handleChange();
  // }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      qty: "0",
      altezza: "0",
      larghezza: "0",
      architrave: "0",
      spallettaSX: "0",
      spallettaDX: "0",
      SMuroSuperiore: "0",
      SMuroSinistro: "0",
      SMuroDestro: "0",
      PGarage: "0",
      locale_con_accesso: false,
      isDebordante: false,
      withDoor: false,
      installazioneTraversa: InstallationType.oltre_luce,
      installazioneMontanteDx: InstallationType.oltre_luce,
      installazioneMontanteSx: InstallationType.oltre_luce,
      with_side_door: false
    },
    //validationSchema: validationSchema,
    onSubmit: async (values) => {
      values.architrave = state.architrave;
      values.SMuroSuperiore = state.SMuroSuperiore;
      values.PGarage = state.PGarage;
      values.SMuroSinistro = state.SMuroSinistro;
      values.spallettaSX = state.spallettaSinistra;
      values.spallettaDX = state.spallettaDestra;
      values.SMuroDestro = state.SMuroDestro;
      values.larghezza = state.larghezza;
      values.altezza = state.altezza;
      const valid = validationSchema.isValidSync(values);
      if (!valid) {
        setErrorVincolo("Attenzione, assicurati di aver inserito tutte le misure necessarie.");
        return;
      }

      setSubmit(true);
      try {        
        let res = await axios.post(`${process.env.REACT_APP_API_URL}/dimensioni`, {
          id: state.customer ? state.customer.id : state.user.id,
          qty: values.qty,
          category_id: state.idPorta,
          quote: state.quoteId,
          altezza: state.altezza,
          larghezza: state.larghezza,
          architrave: state.architrave,
          spallettaSX: state.spallettaSinistra,
          spallettaDX: state.spallettaDestra,
          SMuroSuperiore: state.SMuroSuperiore,
          SMuroSinistro: state.SMuroSinistro,
          SMuroDestro: state.SMuroDestro,
          PGarage: state.PGarage,
          locale_con_accesso: state.selectedD,
          isDebordante: formik.values.isDebordante,
          withDoor: state.isPorticina,
          installazioneTraversa: formik.values.installazioneTraversa,
          installazioneMontanteDx: formik.values.installazioneMontanteDx,
          installazioneMontanteSx: formik.values.installazioneMontanteSx,
          with_side_door: state.isPorticinaAffiancata,
        }, axiosConfig);

        dispatch(baseActions.setIdInstallazioneTraversa(formik.values.installazioneTraversa));
        dispatch(baseActions.setIdInstallazioneMontanteDx(formik.values.installazioneMontanteDx));
        dispatch(baseActions.setIdInstallazioneMontanteSx(formik.values.installazioneMontanteSx));
        dispatch(baseActions.setDimensione(true));

        setSubmit(false);

        if (res.data.error === 1) {
          setErrorVincolo(res.data.message);
        }
        if (res.data.message === "modal") {
          if (res.data.data.lunghezza && res.data.data.lunghezza.length > 0 && res.data.data.altezza && res.data.data.altezza.length > 0) {
            setModal(true);
            setDataModal(res.data.data);
            setLoading(false);
          } else {
            setErrorVincolo("Siamo spiacenti, non è possibile determinare le dimensioni della porta. Verificare le misure inserite.");
            setLoading(false);
          }
          return;
        }
        if (res.data.data === "Warning") {
          setWarning(res.data.message);
          //formik.setFieldValue("installazione", 7);
          setLoading(false);
          return;
        }
      } catch (error) {
        setSubmit(false);
        console.log(error);
      }
    },
  });

  if ("error" == data.state) return <div>failed to load</div>;
  if ("loading" == data.state) return <Loading />;

  return (
    <LayoutPage>
      <div style={{ flex: "0 0 auto" }}>
        <TopBar />

        <div className={"d-flex justify-content-between p-3 title-configuration-main"}>
          <div className="d-flex flex-column" style={{ lineHeight: "1" }}>
            <h2 className="h2 fw-bold">
              Nuova configurazione {getProductName(state.idPorta)} (#{state.quoteId})
            </h2>
          </div>
          <div className={"d-flex justify-content-between align-items-center"}>
            {/* <Button variant={deleteClickCount == 0 ? "outlined" : "contained"} color="error" className="me-3 px-2">
                    <RemoveCircleOutlineOutlinedIcon />
                    <span className="ms-2">{deleteClickCount == 0 ? "ELIMINA" : "CONFERMA"}</span>
                </Button> */}
                <DeleteConfigurationButton 
                  quoteId ={state.quoteId}
                  currentUser={state.user}
                />
                <Button variant="contained" color="secondary" onClick={() =>goToStack(getLastIndex())}>
                    <CloseIcon />
                    <span className="ms-2">CHIUDI</span>
                </Button>
            </div>
        </div>

        <Grid
          className="my-tabs"
          container
          display={{ xs: "none", sm: "none", md: "flex" }}
          >
          <TabsCustom
            value={value}
            setValue={setValue}
            count={state}
            id={state.idPorta}
            handleChange={handleChange}
            axios_conf={axiosConfig}
            url={`${process.env.REACT_APP_API_URL}/categories-steps`}
          />
        </Grid>
      </div>
      <div style={{ flex: "1 1 auto", minHeight: "0" }}>
        {data.dimensioni && <GridPreventivi
          dataSend={{
            quote_id: state.quoteId,
            category_id: state.idPorta,
            slug: location.pathname.substring(1),
          }}
          axiosConfig={axiosConfig}
          url={`${process.env.REACT_APP_API_URL}/photo-preventivi`}
          dimensioni={data.dimensioni && data.dimensioni}>
          <h5 className="text-primary">Nuova configurazione</h5>

          <form onSubmit={formik.handleSubmit}>
            <div>
              <TextField
                variant="outlined"
                label="Quantità"
                type="number"
                className="mt-3 w-full"
                value={formik.values.qty}
                onChange={(e) => formik.setFieldValue("qty", e.target.value)}
                onBlur={(e) => {
                  if (!isValidQta(Number(e.target.value))) {
                    setErroreQta("Valore non valido");
                    return;
                  }
                  setErroreQta(null);
                  setQty(e.target.value)
                }}
                error={erroreQta != null}
                helperText={erroreQta}
              />

              {state.idPorta == 3 && <>
                <FormControl fullWidth className="mt-3">
                  <InputLabel id="debordante">Porta debordante</InputLabel>
                  <Select
                    labelId="debordante"
                    value={formik.values.isDebordante ? "true" : "false"}
                    label="Porta debordante"
                    onChange={(e) => {
                      dispatch(baseActions.setIsDebordante(e.target.value == "true"));
                      formik.setFieldValue("isDebordante", e.target.value == "true");
                    }}>
                    <MenuItem value="true">SI</MenuItem>
                    <MenuItem value="false">NO</MenuItem>
                  </Select>
                </FormControl>
              </>}

              <FormControl fullWidth className="mt-3">
                <InputLabel id="tipoInstallazioneTraversa">Installazione traversa</InputLabel>
                <Select
                  labelId="tipoInstallazioneTraversa"
                  value={formik.values.installazioneTraversa}
                  label="Installazione traversa"
                  onChange={(e) => {
                    formik.setFieldValue("installazioneTraversa", e.target && e.target.value);
                  }}>
                  <MenuItem value={InstallationType.in_luce}>In Luce</MenuItem>
                  <MenuItem value={InstallationType.oltre_luce}>Oltre Luce</MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth className="mt-3">
                <InputLabel id="tipoInstallazioneMontanteSx">Installazione montante SX</InputLabel>
                <Select
                  labelId="tipoInstallazioneMontanteSx"
                  value={formik.values.installazioneMontanteSx}
                  label="Installazione montante SX"
                  onChange={(e) => {
                    formik.setFieldValue("installazioneMontanteSx", e.target && e.target.value);
                  }}>
                  <MenuItem value={InstallationType.in_luce}>In Luce</MenuItem>
                  <MenuItem value={InstallationType.oltre_luce}>Oltre Luce</MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth className="mt-3">
                <InputLabel id="tipoInstallazioneMontanteDx">Installazione montante DX</InputLabel>
                <Select
                  labelId="tipoInstallazioneMontanteDx"
                  value={formik.values.installazioneMontanteDx}
                  label="Installazione montante DX"
                  onChange={(e) => {
                    formik.setFieldValue("installazioneMontanteDx", e.target && e.target.value);
                  }}>
                  <MenuItem value={InstallationType.in_luce}>In Luce</MenuItem>
                  <MenuItem value={InstallationType.oltre_luce}>Oltre Luce</MenuItem>
                </Select>
              </FormControl>
              <div className="d-xl-none">
                  <TextField
                      variant="outlined"
                      label="Altezza Vuoto"
                      type="number"
                      className="mt-3 w-full"
                      value={formik.values.altezza}
                      onChange={(e) => formik.setFieldValue("altezza", Number(e.target.value))}
                      onBlur={(e) => dispatch(baseActions.setAltezza(Number(e.target.value)))}
                  />

                  <TextField
                      variant="outlined"
                      label="Larghezza Vuoto"
                      type="number"
                      className="mt-3 w-full"
                      value={formik.values.larghezza}
                      onChange={(e) => formik.setFieldValue("larghezza", Number(e.target.value))}
                      onBlur={(e) => dispatch(baseActions.setLarghezza(Number(e.target.value)))}
                  />

                  <TextField
                      variant="outlined"
                      label="Profondità Garage"
                      type="number"
                      className="mt-3 w-full"
                      value={formik.values.PGarage}
                      onChange={(e) => formik.setFieldValue("PGarage", Number(e.target.value))}
                      onBlur={(e) => dispatch(baseActions.setPGarage(Number(e.target.value)))}
                  />

                  <TextField
                      variant="outlined"
                      label="Altezza Architrave"
                      type="number"
                      className="mt-3 w-full"
                      value={formik.values.architrave}
                      onChange={(e) => formik.setFieldValue("architrave", Number(e.target.value))}
                      onBlur={(e) => dispatch(baseActions.setArchitrave(Number(e.target.value)))}
                  />

                  <TextField
                      variant="outlined"
                      label="Spessore Architrave"
                      type="number"
                      className="mt-3 w-full"
                      value={formik.values.SMuroSuperiore}
                      onChange={(e) => formik.setFieldValue("SMuroSuperiore", Number(e.target.value))}
                      onBlur={(e) => dispatch(baseActions.setSMuroSuperiore(Number(e.target.value)))}
                  />

                  <TextField
                      variant="outlined"
                      label="Larghezza Spalletta Destra"
                      type="number"
                      className="mt-3 w-full"
                      value={formik.values.spallettaDX}
                      onChange={(e) => formik.setFieldValue("spallettaDX", Number(e.target.value))}
                      onBlur={(e) => dispatch(baseActions.setSpallettaDestra(Number(e.target.value)))}
                  />

                  <TextField
                      variant="outlined"
                      label="Spessore Spalletta Destra"
                      type="number"
                      className="mt-3 w-full"
                      value={formik.values.SMuroDestro}
                      onChange={(e) => formik.setFieldValue("SMuroDestro", Number(e.target.value))}
                      onBlur={(e) => dispatch(baseActions.setSMuroDestro(Number(e.target.value)))}
                  />

                  <TextField
                      variant="outlined"
                      label="Larghezza Spalletta Sinistra"
                      type="number"
                      className="mt-3 w-full"
                      value={formik.values.spallettaSX}
                      onChange={(e) => formik.setFieldValue("spallettaSX", Number(e.target.value))}
                      onBlur={(e) => dispatch(baseActions.setSpallettaSinistra(Number(e.target.value)))}
                  />

                  <TextField
                      variant="outlined"
                      label="Spessore Spalletta Sinistra"
                      type="number"
                      className="mt-3 w-full"
                      value={formik.values.SMuroSinistro}
                      onChange={(e) => formik.setFieldValue("SMuroSinistro", Number(e.target.value))}
                      onBlur={(e) => dispatch(baseActions.setSMuroSinistro(Number(e.target.value)))}
                  />
              </div>


              <FormControlLabel
                className="w-full mt-4"
                control={
                  <Checkbox
                    checked={formik.values.locale_con_accesso}
                    onChange={(e) => {
                      setChecked(e.target.checked);
                      dispatch(baseActions.setSelectedD(e.target.checked));
                      formik.setFieldValue("locale_con_accesso", e.target.checked);
                    }}
                    sx={{ marginTop: "0", marginBottom: "0" }}
                  />
                }
                label="Locale garage con altro accesso"
                sx={{ marginTop: "0", marginBottom: "0", textTransform: "uppercase" }}
              />

              {state.idPorta == 3 && <FormControlLabel
                className="w-full"
                control={
                  <Checkbox
                    checked={formik.values.withDoor}
                    onChange={(e) => {
                      dispatch(baseActions.setIsPorticina(e.target.checked));
                      formik.setFieldValue("withDoor", e.target.checked);
                    }}
                    sx={{ marginTop: "0", marginBottom: "0" }}
                  />
                }
                label="Aggiungi portina pedonale integrata"
                sx={{ marginTop: "0", marginBottom: "0", textTransform: "uppercase" }}
              />}

              <FormControlLabel
                className="w-full"
                control={
                  <Checkbox
                    checked={formik.values.with_side_door}
                    onChange={(e) => {
                      setSwitchPorticinaAffiancata(e.target.checked);
                      dispatch(baseActions.setIsPorticinaAffiancata(e.target.checked));
                      formik.setFieldValue("with_side_door", e.target.checked);
                    }}
                    sx={{ marginTop: "0", marginBottom: "0" }}
                  />
                }
                label="Aggiungi portina pedonale affiancata"
                sx={{ marginTop: "0", marginBottom: "0", textTransform: "uppercase" }}
              />
            </div>

            <div className="d-flex flex-row-reverse mt-3">
              <Button disabled={submit} variant="contained" className="ps-3 pe-1" type={"submit"}>
                <span>Avanti</span>
                <NavigateNextIcon />
              </Button>
            </div>
          </form>
        </GridPreventivi>}

        <DialogCustom
          title={"Conferma misura"}
          open={modal}
          handleClose={() => saveSector()}
          handleCancel={() => setModal(false)}
          loadingModal={false/*modal.state == "save"*/}
          content={
            <>
              <RadioItemDimensioni
                modalValueLarghezza={modalValueLarghezza}
                setModalValueLarghezza={setModalValueLarghezza}
                modalValueAltezza={modalValueAltezza}
                setModalValueAltezza={setModalValueAltezza}
                data={dataModal}
                count={state}
              />

              {(errorModal !== "") && (
                <Alert severity={"error"}>{errorModal}</Alert>
              )}
            </>
          }
        />

        <DialogCustom
          title={"Seleziona un opzione"}
          open={modalOptions.show}
          handleClose={setInstallationAccessories}
          handleCancel={() => setModalOptions({ ...modalOptions, show: false })}
          //loadingModal={loadingModal}
          content={
            <>
              {modalOptions.options && (
                <DialogOptions
                  options={modalOptions.options}
                  selectedCrossbeam={modalOptions.selectedCrossbeam}
                  selectedPillars={modalOptions.selectedPillars}
                  onSetCrossbeam={value => setModalOptions({ ...modalOptions, selectedCrossbeam: value })}
                  onSetPillars={value => setModalOptions({ ...modalOptions, selectedPillars: value })}
                />
              )}

              {"error" == modalOptions.state && (
                <Alert sx={{ marginTop: "1rem" }} severity={"error"}>{modalOptions.error}</Alert>
              )}
            </>
          }
        />

        {errorVincolo && <div className="d-flex justify-content-center py-3" style={{ position: "fixed", left: "0", bottom: "0", width: "100%" }}>
          <Alert variant="filled" severity="warning" sx={{ zIndex: "1500" }} onClose={() => setErrorVincolo(null)}>
            <AlertTitle>Attenzione...</AlertTitle>
            {errorVincolo}
          </Alert>
        </div>}
      </div>
    </LayoutPage>
  );
};

const DialogOptions = ({ options, selectedCrossbeam, selectedPillars, onSetCrossbeam, onSetPillars }) => {
  return (
    <>
      {/* TRAVERSA */}
      {options.crossbeam && (
        <Typography
          color={"primary"}
          sx={{
            textAlign: "start",
            fontSize: 20,
          }}>
          <span>Traversa</span>
        </Typography>
      )}
      {options.crossbeam && (
        <>
          {options.crossbeam.map(o =>
            <div key={o.item.id} className={"flex cursor-pointer"} style={{ marginTop: ".5rem", alignItems: "start" }}>
              <Radio
                sx={{ padding: ".125rem .25rem" }}
                checked={o.item.id == selectedCrossbeam}
                onChange={(evt) => onSetCrossbeam && onSetCrossbeam(evt.target.value)}
                value={o.item.id}
                name={o.item.name}
              />

              <Typography
                sx={{
                  fontSize: 16,
                  textAlign: "left"
                }}>
                {o.item.name} {o.recommended && <span> - <strong>(Scelta consigliata)</strong></span>}
              </Typography>
            </div>
          )}

          <div key={-1} className={"flex cursor-pointer"} style={{ marginTop: ".5rem", alignItems: "start" }}>
            <Radio
              sx={{ padding: ".125rem .25rem" }}
              checked={-1 == selectedCrossbeam}
              onChange={(evt) => onSetCrossbeam && onSetCrossbeam(evt.target.value)}
              value={-1}
              name="NO_CHOICE"
            />

            <Typography
              sx={{
                fontSize: 16,
                textAlign: "left"
              }}>
              Nessuna delle precedenti opzioni
            </Typography>
          </div>
        </>
      )}

      {/* MONTANTI */}
      {options.pillars && (
        <Typography
          color={"primary"}
          sx={{
            textAlign: "start",
            fontSize: 20,
            marginTop: ".5rem"
          }}>
          <span>Montanti</span>
        </Typography>
      )}
      {options.pillars && (
        <>
          {options.pillars.map(o =>
            <div key={o.item.id} className={"flex cursor-pointer"} style={{ marginTop: ".5rem", alignItems: "start" }}>
              <Radio
                sx={{ padding: ".125rem .25rem" }}
                checked={o.item.id == selectedPillars}
                onChange={(evt) => onSetPillars && onSetPillars(evt.target.value)}
                value={o.item.id}
                name={o.item.name}
              />

              <Typography
                sx={{
                  fontSize: 16,
                  textAlign: "left"
                }}>
                {o.item.name} {o.recommended && <span> - <strong>(Scelta consigliata)</strong></span>}
              </Typography>
            </div>
          )}

          <div key={-2} className={"flex cursor-pointer"} style={{ marginTop: ".5rem", alignItems: "start" }}>
            <Radio
              sx={{ padding: ".125rem .25rem" }}
              checked={-2 == selectedPillars}
              onChange={(evt) => onSetPillars && onSetPillars(evt.target.value)}
              value={-2}
              name={"NO_CHOICE"}
            />

            <Typography
              sx={{
                fontSize: 16,
                textAlign: "left"
              }}>
              Nessuna delle precedenti opzioni
            </Typography>
          </div>
        </>
      )}
    </>
  );
}

const useStyles = makeStyles({
  root: {
    "& MuiTabs-flexContainer css-heg063-MuiTabs-flexContainer": {
      justifyContent: "center",
    },
  },
});

export default Dimensioni;
